module.exports = __webpack_public_path__ + "static/media/CSK-horiz-desktop-default@2x.fbf9c0f5.png";